<template>
  <div class="Timer clearfix" v-if="endTimes">
    <span class="timer_description">{{ description }}</span>
    <span class="timer_data">{{ remainingTime | timeFilter }}</span>
  </div>
</template>
<script>
  export default {
    name: 'Timer',
    props: {
      endTimes: {
        type: Number,
        default: 60
      },
      description: {
        type: String,
        default: '剩余时间：'
      }
    },
    data() {
      return {
        countDown: null,
        remainingTime: 0
      }
    },
    watch: {
      endTimes(newVal) {
        if (newVal <= 0) {
          clearInterval(this.countDown)
          this.$emit('submit')
        } else {
          this.remainingTime = newVal
        }
      }
    },
    mounted() {
      this.remainingTime = this.endTimes
      this.countDown = setInterval(() => {
        this.remainingTime--
        this.$emit('update:endTimes', this.remainingTime)
      }, 1000)
    },
    beforeDestroy() {
      clearInterval(this.countDown)
    },
    stopTimer() {
      if(this.countDown != null) {
        clearInterval(this.countDown)
        this.countDown = null
      }
    }
  }
</script>
<style lang="scss" scoped>
  .Timer {
    float: left;
    height: 33px;
    margin-right: 20px;

    .timer_description {
      float: left;
      height: 54px;
      line-height: 54px;
      color: #ff0;
      font-size: 16px;
      display: inline-block;
      //background: url(~@/assets/images/cta/d11.png) no-repeat left;
      //padding-left:30px;
    }

    .timer_data {
      float: left;
      display: inline-block;
      font-size: 16px;
      color: #ff0;
      height: 54px;
      line-height: 54px;
    }
  }
</style>
